import { map } from 'rxjs/operators';
import { EMONEY_ASSET, EMONEY_CLIENT, EMONEY_HOLDING, EMONEY_PLAN } from 'IntegrationsApp/ts/constants';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class EMoneyIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getEMoneyIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.EMONEY_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    deactivateEMoneyIntegration() {
        const url = this.urlsService.INTEGRATIONS.EMONEY_INTEGRATION_AUTH;
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    getEMoneyClientSearchResults(searchTerms, page) {
        const urlParams = { searchType: EMONEY_CLIENT };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.EMONEY_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getEMoneyPlanSearchResults(clientId, page) {
        const urlParams = { searchType: EMONEY_PLAN };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.EMONEY_SEARCH, urlParams)}?client_id=${clientId}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getEMoneyAssetSearchResults(clientId, planId, page) {
        const urlParams = { searchType: EMONEY_ASSET };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.EMONEY_SEARCH, urlParams)}?client_id=${clientId}&plan_id=${planId}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getEMoneyHoldingSearchResults(clientId, assetId, page) {
        const urlParams = { searchType: EMONEY_HOLDING };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.EMONEY_SEARCH, urlParams)}?client_id=${clientId}&asset_id=${assetId}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getAllEMoneyHoldingSearchResults(clientId, assets, page) {
        const urlParams = { searchType: EMONEY_HOLDING };
        const assetIds = assets.filter((asset) => !asset.importAsSingleHolding).map((asset) => asset.id);
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.EMONEY_SEARCH, urlParams)}?client_id=${clientId}&asset_ids=${assetIds.join(',')}&page=${page}`;
        const singleHoldings = assets
            .filter((asset) => asset.importAsSingleHolding)
            .map((asset) => ({
            id: asset.id,
            ticker: asset.name,
            description: asset.name,
            marketPrice: asset.value,
            marketValue: asset.value,
            units: 1,
        }));
        return this.ajaxService.getDataObserveBody(url).pipe(map((response) => {
            return {
                ...response,
                saerchResults: [...response.searchResults, ...singleHoldings],
            };
        }));
    }
    importEMoneyHoldings(postParams) {
        const url = this.urlsService.getUrl(this.urlsService.INTEGRATIONS.EMONEY_IMPORT_HOLDINGS);
        return this.ajaxService.postJsonDataObserveBody(url, {
            ...postParams,
            ids: postParams.selectedAssets.map((asset) => asset.id),
            holdings: postParams.selectedAssets,
        });
    }
}
EMoneyIntegrationService.ɵfac = function EMoneyIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EMoneyIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
EMoneyIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: EMoneyIntegrationService, factory: EMoneyIntegrationService.ɵfac, providedIn: 'root' });
